const configure = {
  // appUrl: "/",
  // apiUrl: "https://api.zithas.com/api",
  // imgUrl: "https://api.zithas.com/application/public",   // Live
  // nodeApi: 'https://napi.zithas.com/api',
  // nodeImgApi: 'https://napi.zithas.com',
  // exchangeKey: "HBhbjhBY9Zui0q8XUT0O7BcuFgs9l5q5",
  type: 2, // Earth 

  // imgUrl: "https://mars.ztpl.net/application/public",
  // apiUrl: "https://mars.ztpl.net/api",                   // Ztpl

  apiUrl: "https://edemoapi.zithas.com/api",
  imgUrl: "https://edemoapi.zithas.com/application/public",    // demo Ztpl
  nodeApi: 'https://endemoapi.zithas.com/api',
  nodeImgApi: 'https://endemoapi.zithas.com',
  exchangeKey: "M5CQtQbJko1A2CDN4tjHvF9qFTkgQIoG",

  appUrl: "/finance-india/",
  // appUrl: "/finance-usa/", 

  location: [1], // india 1 | US 3
  dashboardModule: 2
  // earth - 1 (default)
  // finance - 2
  // hr - 3
  // crm - 4
}

export default configure